import React from 'react';
import { Button } from './ui/Button';
export function FinalCTASection() {
  return <section className="py-24 px-4 bg-white text-center" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2D3648] mb-6 font-heading" data-id="element-38">
          Tu hijo está a 21 días de sentirse orgulloso de sí mismo.
        </h2>
        <p className="text-lg text-[#4A5568] mb-10 max-w-2xl mx-auto" data-id="element-39">
          No dejes pasar otro mes de frustración. Dale las herramientas que
          necesita para descubrir que leer puede ser un placer, no un castigo.
        </p>

        <a href="https://www.gaiadigitalpro.com/checkouts/cn/hWN97cYIrZq0N6nxejFJOld3/es-ar?_r=AQABO5WkZAviKo3oQFFbDGNAwsqGY8jRmCI-2Na28krQ6Q0&preview_theme_id=163563503651" target="_blank" rel="noopener noreferrer" data-id="element-40">
          <Button variant="primary" size="lg" className="w-full md:w-auto px-12 py-6 text-lg rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300" data-id="element-41">
            QUIERO EMPEZAR HOY MISMO
          </Button>
        </a>
      </div>
    </section>;
}